import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '../services/translate.service';

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const translate = inject(TranslateService);
  const separator = req.url.includes('?') ? '&' : '?';
  const langReq = req.clone({
    url: `${req.url}${separator}lang=${translate.currentLang()}`,
  });
  return next(langReq);
};
